import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const customerSocialsTypes = async () =>
  axios.get(Routes.CUSTOMER_SOCIALS_TYPES);

export const useCustomerSocialsTypes = () =>
  useQuery({
    queryKey: [Keys.CUSTOMER_SOCIALS_TYPES_QRY],
    queryFn: customerSocialsTypes,
  });
